/* eslint-disable react/no-unescaped-entities */
/* eslint-disable react-hooks/exhaustive-deps */
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import Typography from '@material-ui/core/Typography';
import OaLabel from '@orientaction/commons/OaLabel';
import RichEditor from '@orientaction/commons/RichEditor';
import StyledDropzone from '@orientaction/commons/StyledDropzone';
import { AdminTestContext } from '@orientaction/Context';
import classNames from 'classnames';
import { useCallback, useContext, useEffect, useRef, useState } from 'react';
import style from './style';
import { Grid } from '@material-ui/core';
import { cloneDeep } from 'lodash';

const resolveTypeMedia = (imageValue: string, videoValue: string) => {
  const hasImage = Boolean(imageValue?.trim());
  const hasVideo = Boolean(videoValue?.trim());

  if (hasImage && hasVideo) return 'both';
  if (hasImage) return 'image';
  if (hasVideo) return 'video';
  return '';
};

const placeholder = () => {
  return (
    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
      <span style={{ fontSize: 26, margin: 8 }}>+</span>
      <span>Importer une image</span>
      <span>
        <i>1920*1360 pixels</i>
      </span>
    </div>
  );
};

const VariableForm = ({ idAglomeration }: any) => {
  const [variableName, setVariableName] = useState('');
  const [title, setTitle] = useState('');
  const [description, setDescription] = useState('');
  const [image, setImage] = useState('');
  const [codeColor, setCodeColor] = useState('');
  const [errors, setErrors] = useState({
    variableName: false,
    title: false,
    minInterval: false,
    maxInterval: false,
    media: false,
  });
  const [minInterval, setMinInterval] = useState('');
  const [maxInterval, setMaxInterval] = useState('');
  const [typeMedia, setTypeMedia] = useState<string>('');
  const [video, setVideo] = useState('');
  const [textRestitutionChart, setTextRestitutionChart] = useState('');

  const quillRef1: any = useRef();

  const { test, updateTest } = useContext<any>(AdminTestContext);

  const classes = style();

  const initializeState = useCallback(() => {
    const { variableAglomerationToEdit } = test;
    setVariableName(variableAglomerationToEdit.name || '');
    setTitle(variableAglomerationToEdit.title || '');
    setDescription(variableAglomerationToEdit.description || '');
    setImage(variableAglomerationToEdit.image);
    setCodeColor(variableAglomerationToEdit?.codeColor);
    setMinInterval(variableAglomerationToEdit?.minInterval?.toString() || '0');
    setMaxInterval(variableAglomerationToEdit?.maxInterval?.toString() || '100');
    setVideo(variableAglomerationToEdit?.video || '');
    setTypeMedia(variableAglomerationToEdit?.typeMedia || 'image');
    setTextRestitutionChart(variableAglomerationToEdit?.textRestitutionChart || '');
  }, []);

  const handleNameChange = (e: any) => {
    setVariableName(e.target.value);
    if (errors.variableName) {
      setErrors((state: any) => ({ ...state, variableName: false }));
    }
  };

  const handleTitleChange = (value: any) => {
    setTitle(value);
    if (errors.title) {
      setErrors((state: any) => ({ ...state, title: false }));
    }
  };

  const handleDescriptionChange = (value: any) => {
    setDescription(value);
  };

  const handleCodeColorChange = (e: any) => {
    setCodeColor(e.target.value);
  };

  const handleTextRestChatChange = (e: any) => {
    setTextRestitutionChart(e.target.value);
  };

  const resetLocalState = () => {
    setVariableName('');
    setTitle('');
    setDescription('');
    setImage('');
    setVideo('');
    setTypeMedia('');
  };

  const generateId = () => Date.now().toString(36) + Math.random().toString(36).substr(2, 9);

  const handleSubmit = (e: any) => {
    e.preventDefault();
    if (!variableName?.trim().length) {
      setErrors((state: any) => ({ ...state, variableName: true }));
      return;
    }

    if (!title?.trim().length) {
      setErrors((state: any) => ({ ...state, title: true }));
      return;
    }

    if (!variableName?.trim().length) {
      setErrors((state: any) => ({ ...state, variableName: true }));
      return;
    }

    if (!title?.trim().length) {
      setErrors((state: any) => ({ ...state, title: true }));
      return;
    }

    if (isInterval && !minInterval?.trim().length) {
      setErrors((state: any) => ({ ...state, minInterval: true }));
      return;
    }

    if (isInterval && !maxInterval?.trim().length) {
      setErrors((state: any) => ({ ...state, maxInterval: true }));
      return;
    }

    if (!isSimpleDiagram && !image?.trim().length && !video?.trim().length) {
      setErrors((state: any) => ({ ...state, media: true }));
      return;
    }

    const resolvedTypeMedia = resolveTypeMedia(image, video);

    const { aglomerations } = test;
    const cloneAglomerations = cloneDeep([...aglomerations]);

    if (test.variableAglomerationToEdit) {
      const { index, isNew } = test.variableAglomerationToEdit;
      const firstSlice = cloneAglomerations[idAglomeration]?.variables.slice(0, index);
      const secondSlice = cloneAglomerations[idAglomeration]?.variables.slice(index + 1);
      cloneAglomerations[idAglomeration].variables = [
        ...firstSlice,
        {
          id: test.variableAglomerationToEdit.id,
          name: variableName,
          title,
          description,
          image,
          video,
          typeMedia: resolvedTypeMedia,
          isNew: !!isNew,
          codeColor,
          minInterval: parseInt(minInterval, 10),
          maxInterval: parseInt(maxInterval, 10),
          textRestitutionChart,
        },
        ...secondSlice,
      ];
      updateTest({
        aglomerations: cloneAglomerations,
        variableAglomerationDrawerOpen: false,
        variableAglomerationToEdit: undefined,
      });
    } else {
      const lastVariable = cloneAglomerations[idAglomeration]?.variables[test.variables.length - 1];
      cloneAglomerations[idAglomeration]?.variables.push({
        id: generateId(),
        name: variableName,
        title,
        description,
        image,
        video,
        typeMedia: resolvedTypeMedia,
        isNew: true,
        codeColor,
        minInterval: parseInt(minInterval, 10),
        maxInterval: parseInt(maxInterval, 10),
        textRestitutionChart,
      });
      updateTest({
        aglomerations: cloneAglomerations,
        variableAglomerationDrawerOpen: false,
      });
    }
    resetLocalState();
  };

  const handleFileUrlChange = (url: string) => {
    setImage(url);
    // Effacer l'erreur media si une image est ajoutée
    if (url && errors.media) {
      setErrors((state: any) => ({ ...state, media: false }));
    }
  };

  const handleDeleteFile = () => {
    setImage('');
  };

  useEffect(() => {
    if (test.variableAglomerationToEdit) {
      initializeState();
    }
  }, [initializeState, test.variableAglomerationToEdit]);

  const variableNumber = test.variableAglomerationToEdit
    ? test?.variableAglomerationToEdit?.index + 1
    : test?.aglomerations[idAglomeration]?.variables?.length + 1;


  const { diagram } = test.test;
  const isSimpleDiagram = diagram?.id === 1;
  const isFullScore = diagram?.id === 5;
  const isInterval = true;

  // Réinitialiser les intervalles avec des valeurs par défaut pour les nouvelles variables
  // useEffect(() => {
  //   if (isInterval && !test.variableAglomerationToEdit) {
  //     if (
  //       minInterval === '' ||
  //       minInterval === 'undefined' ||
  //       minInterval === 'null' ||
  //       isNaN(parseInt(minInterval, 10))
  //     ) {
  //       setMinInterval('0');
  //     }
  //     if (
  //       maxInterval === '' ||
  //       maxInterval === 'undefined' ||
  //       maxInterval === 'null' ||
  //       isNaN(parseInt(maxInterval, 10))
  //     ) {
  //       setMaxInterval('100');
  //     }
  //   }
  // }, [isInterval, test.variableAglomerationToEdit, minInterval, maxInterval]);

  const handleMinIntervalValueChange = (e: any) => {
    if (parseInt(e.target.value, 10) >= 0 || e.target.value === '') {
      setMinInterval(e.target.value === '' ? '' : parseInt(e.target.value, 10).toString());
      if (errors.minInterval) {
        setErrors({ ...errors, minInterval: false });
      }
    }
  };

  const handleMaxIntervalValueChange = (e: any) => {
    if (parseInt(e.target.value, 10) >= 0 || e.target.value === '') {
      setMaxInterval(e.target.value === '' ? '' : parseInt(e.target.value, 10).toString());
      if (errors.maxInterval) {
        setErrors({ ...errors, maxInterval: false });
      }
    }
  };

  const handleVideoURL = (e: any) => {
    setVideo(e.target.value);
    if (e.target.value && errors.media) {
      setErrors((state: any) => ({ ...state, media: false }));
    }
  };

  return (
    <form className={classes.flexContainer} onSubmit={handleSubmit}>
      <Typography className={classes.variableFormTitle} component="h3">
        Restitution N°{variableNumber}
      </Typography>
      <div className={classNames(classes.marginTop, classes.fullWidth)}>
        <OaLabel>Nom de la restitution</OaLabel>
        <TextField
          id="test-variable-name"
          variant="outlined"
          className={classNames(classes.formInput, errors.variableName && classes.error)}
          name="variableName"
          value={variableName}
          onChange={handleNameChange}
          placeholder="Nom visible uniquement pour vous"
        />
      </div>
      <div className={classNames(classes.marginTop, classes.fullWidth)}>
        <OaLabel>Titre qui apparaitra lors du résultat</OaLabel>
        <RichEditor
          value={title}
          handleChange={handleTitleChange}
          placeholder="Titre que verront les bénéficiaires sur la page de résultats"
          hasError={errors.title}
        />
      </div>
      <div className={classNames(classes.marginTop, classes.fullWidth)}>
        <OaLabel>Description de la restitution</OaLabel>
        <RichEditor
          ref={quillRef1}
          value={description}
          handleChange={handleDescriptionChange}
          placeholder="Texte qui sera affiché sur la page de résultats"
          isMultiline={true}
        />
      </div>
      {isFullScore && (
        <div className={classNames(classes.marginTop, classes.fullWidth)}>
          <OaLabel>
            Couleur personnalisée <span>(en code hexadécimal, ex : #FF5733)</span>
          </OaLabel>
          <TextField
            id="test-code-color"
            variant="outlined"
            className={classNames(classes.formInput)}
            name="codeColor"
            value={codeColor}
            onChange={handleCodeColorChange}
            placeholder="Ex : #FF5733"
          />
        </div>
      )}
      {isInterval && (
        <div className={classNames(classes.marginTop, classes.fullWidth)}>
          <OaLabel>Intervalle de déclenchement de la variable à afficher en restitution</OaLabel>
          <div style={{ display: 'flex', alignItems: 'center' }}>
            <span style={{ marginRight: 10, textWrap: 'nowrap' }}>Score compris entre</span>
            <TextField
              id="test-min-interval"
              variant="outlined"
              className={classNames(classes.formInput, errors.minInterval && classes.error)}
              name="minInterval"
              value={minInterval}
              onChange={handleMinIntervalValueChange}
              placeholder="Min."
              type="number"
            />
            <span style={{ marginRight: 10, marginLeft: 10 }}>et</span>
            <TextField
              id="test-max-interval"
              variant="outlined"
              className={classNames(classes.formInput, errors.maxInterval && classes.error)}
              name="maxInterval"
              value={maxInterval}
              onChange={handleMaxIntervalValueChange}
              placeholder="Max."
              type="number"
            />
          </div>
        </div>
      )}
      {!isSimpleDiagram && (
        <div className={classNames(classes.marginTop, classes.fullWidth)}>
          <OaLabel>{`Image et/ou vidéo qui s'afficheront sur la page du résultat du test`}</OaLabel>
          <Grid container={true} spacing={2}>
            <Grid item={true} xs={12} md={6}>
              <Typography variant="body2" style={{ marginBottom: 8, fontWeight: 600 }}>
                Image
              </Typography>
              <StyledDropzone
                fileUrl={image}
                handleFileUrlChange={handleFileUrlChange}
                placeholder={placeholder}
                sectionTop={true}
                error={!!test?.manageError?.image}
                pathPrefix="testVariableImages"
              />
              <div onClick={handleDeleteFile} className={classes.replaceTextContainer}>
                Remplacer
              </div>
            </Grid>
            <Grid item={true} xs={12} md={6}>
              <Typography variant="body2" style={{ marginBottom: 8, fontWeight: 600 }}>
                Vidéo
              </Typography>
              <TextField
                id="test-variable-video"
                variant="outlined"
                className={classNames(classes.formInput, errors.media && classes.error)}
                name="video"
                value={video}
                onChange={handleVideoURL}
                placeholder="Url de la vidéo"
              />
            </Grid>
          </Grid>
          {errors.media && (
            <Typography color="error" variant="body2" style={{ marginTop: 8 }}>
              Merci de renseigner une image ou une vidéo
            </Typography>
          )}
        </div>
      )}
      <div className={classes.marginTop}>
        <Button type="submit" className={classes.btnPrimary}>
          <span className={classes.textHeader}>Valider</span>
        </Button>
      </div>
    </form>
  );
};

export default VariableForm;
